import { IItem, instanceOfIItem } from "./IItem";

export interface INumberingAssosiatable extends IItem {
  getNumberingKeyword(): string;
}

export function instanceOfINumberingAssosiatable(instance: any): instance is INumberingAssosiatable {
  return instance
    && (instance.getNumberingKeyword !== undefined)
    && instanceOfIItem(instance);
}
